import React, { useState } from "react";

import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {
  makeStyles,
  ThemeProvider,
  createMuiTheme,
} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Avatar from "@material-ui/core/Avatar";
import remy from "/usr/src/app/client/img/messageImage_1612839552567.jpg";
import clsx from "clsx";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import Kfunc from "../utill/util";
// import { v4 as uuidv4 } from "uuid";
import { Formik, Form } from "formik";
import * as yup from "yup";

let SignupSchema = yup.object().shape({
  firstName: yup.string().required("This field is required."),
  lastName: yup.string().required("This field is required."),
  email: yup.string().email().required("This field is required."),
  password: yup
    .string()
    .min(6, "Password is too short.")
    .max(20, "Password is too long.")
    .required("This field is required."),
});

const useStyles = makeStyles((theme) => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    margin: theme.spacing(3, 0, 2),
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
    margin: {
      margin: theme.spacing(1),
    },
  },
}));
const theme = createMuiTheme({
  palette: {
    primary: green,
  },
});
function _interopDefault(ex) {
  return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}
export default function Signup() {
  // export const Signup = () => {
  const classes = useStyles();
  /////////////////////////////////BUTON////////////////////////////
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [password, setpassword] = useState("");
  const [paylode, setpaylode] = useState(false);
  const [phone, setphone] = useState();
  const [button, setbutton] = useState(true);
  const [Name, setName] = useState("");
  const [FnameLname, setFnameLname] = useState("");
  const [brance, setbrance] = useState('')
  const timer = React.useRef();

  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });

  React.useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  const handleButtonClick2 = async () => {
    // var database = "BCT_AMS2_RPLC";
    // var table = "whatapp_token";
    // var query = { key: "token", query: "karantoekn" };
    var jsondata = {
      database: "PPP7",
      table: "PKGemployee",
      query: { key: "id", query: phone },
    };
    const check = await Kfunc.databass(jsondata);
    console.log(check);
    try {
      if (check[0].id) {
        console.log("ssssssssss");
        // alert(`${check[0].thprefix} ${check[0].name_th} ${check[0].surname_th}`)
        setFnameLname(
          `${check[0].thprefix} ${check[0].name_th} ${check[0].surname_th}`
        );
        setbrance(check[0].company_ctt)
        setpassword(false);
        setpaylode(check[0]);
        setbutton(false);
        // alert(check[0].line_id);
      }
    } catch (error) {
      setpassword(true);
      console.log("xxxxxxxxxxx");
    }
  };

  const handleButtonClick = async () => {
    if (!loading) {
      setSuccess(false);
      setLoading(true);
      timer.current = window.setTimeout(() => {
        setSuccess(true);
        setLoading(false);
      }, 2000);
    }
  };
  var querystring = _interopDefault(require("querystring"));
  var lineLogin = async () => {
    // if(Name === ''){
    //   return alert('กรุณากรอกข้อมูลให้ครบ')
    // }
    var redirectURI = `https://linetoken.prachakij.com/register`;
    var query = querystring.stringify({
      response_type: "code",
      client_id: "G26i7CWxYxALnVGq6Y8KqX",
      state: `${phone},nulln,${FnameLname},${brance}`,
      scope: "notify",
    });
    var lineAuthoriseURL =
      "https://notify-bot.line.me/oauth/authorize?" +
      query +
      "&redirect_uri=" +
      redirectURI;
    window.location.href = lineAuthoriseURL;
  };

  // componentDidMount() {
  //   // document.title = `You clicked ${this.state.count} times`;
  //   // ChatAPI.subscribeToFriendStatus(
  //   //   this.props.friend.id,
  //   //   this.handleStatusChange
  //   // );
  // }
  // function Example() {
  //   alert('sdfsdfsdfdsf')
  // React.useEffect(() => setbutton(true), [setpassword]);
  //   return null;
  // }
  //   Example()
  /////////////////////////////////BUTON////////////////////////////
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar alt="Remy Sharp" src={remy} className={classes.large} />
        <Typography component="h1" variant="h5">
          สมัครรับแจ้งเตือน
        </Typography>
        <Formik
          initialValues={{
            firstName: "",
            lastName: "",
            email: "",
            password: "",
          }}
          validationSchema={SignupSchema}
          onSubmit={(values) => {
            console.log(values);
          }}
        >
          {({ errors, handleChange, touched }) => (
            <Form className={classes.form}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    error={password === true}
                    variant="outlined"
                    fullWidth
                    onChange={(e) => {
                      e.preventDefault();
                      setphone(e.target.value);
                    }}
                    name="number"
                    label="รหัสพนักงาน"
                    type="number"
                    id="outlined-error-helper-text"
                    // helperText="Incorrect entry."
                    autoComplete="number"
                    helperText={
                      password === true ? "ไม่มีรหัสพนักงานในระบบ" : null
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  {password === false ? (
                    <TextField
                      disabled
                      id="filled-disabled"
                      label="ชื่อ-นามสกุล"
                      value={FnameLname}
                      variant="filled"
                      fullWidth
                      name="number"
                    />
                  ) : null}
                </Grid>
                <Grid item xs={12}>
                  {password === false ? (
                    <TextField
                      disabled
                      id="filled-disabled"
                      label="สาขา"
                      value={brance}
                      variant="filled"
                      fullWidth
                      name="number"
                    />
                  ) : null}
                </Grid>
                {/* <Grid item xs={12}>
                  <TextField
                    error={Name === ""}
                    variant="outlined"
                    fullWidth
                    onChange={(e) => {
                      e.preventDefault();
                      setName(e.target.value);
                    }}
                    name="number"
                    label="ชื่อ-นามสกุล"
                    type="text"
                    id="outlined-error-helper-text"
                    // helperText="Incorrect entry."
                    autoComplete="name"
                    helperText={Name === "" ? "กรุณาใส่ ชื่อ-นามสกุล" : null}
                  />
                </Grid> */}
              </Grid>
              {button === true ? (
                <div className={classes.wrapper}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={buttonClassname}
                    disabled={loading}
                    onClick={handleButtonClick2}
                  >
                    ค้นหา
                  </Button>
                  {loading && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </div>
              ) : null}
              {button === false ? (
                <div className={classes.wrapper}>
                  <ThemeProvider theme={theme}>
                    <Button
                      type="submit"
                      size="large"
                      variant="contained"
                      color="primary"
                      className={classes.margin}
                      disabled={loading}
                      onClick={lineLogin}
                    >
                      Connect Line
                    </Button>
                  </ThemeProvider>
                  {loading && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </div>
              ) : null}
            </Form>
          )}
        </Formik>
      </div>
    </Container>
  );
}



// WEBPACK FOOTER //
// src/page/Signup.js